import { createStructuredSelector } from 'reselect'
import { data } from '../SecurityPatchChart/security-patch-chart.selector'

export default createStructuredSelector({
  data
})
